module.exports = __webpack_public_path__ + "img/Shape-4.9d2cb571.svg";